import { useQuery } from '@tanstack/react-query'
import { Button, Select, type SelectProps } from 'antd'
import { useRemoteKeyword } from '@/hooks/use-remote-keyword.ts'
import { useTRPC } from '@/trpc/react.ts'

type Props = Pick<SelectProps<number[]>, 'value' | 'onChange' | 'id' | 'disabled' | 'onBlur'>

export function CustomerTagSelect(props: Props) {
  const trpc = useTRPC()
  const search = useRemoteKeyword()
  const tags = useQuery({
    ...trpc.lookup.customerTags.queryOptions({
      purpose: 'customer.read',
      keyword: search.keyword,
      selectedIds: props.value ?? undefined
    }),
    staleTime: 60_000
  })
  return (
    <Select<number[]>
      {...props}
      allowClear
      className="w-full"
      mode="multiple"
      maxCount={50}
      loading={tags.isFetching}
      options={(tags.data ?? []).map((tag) => ({ label: tag.name, value: tag.id }))}
      placeholder="输入标签名称搜索，可多选"
      showSearch={{ filterOption: false, onSearch: search.onSearch }}
      notFoundContent={
        tags.isError ? (
          <Button type="link" onClick={() => void tags.refetch()}>
            加载失败，点击重试
          </Button>
        ) : tags.isFetching ? (
          '加载中…'
        ) : (
          '暂无匹配标签'
        )
      }
    />
  )
}
